import * as yup from "yup";
export const T4SummarySetupSchema = yup.object().shape({
  // transmitterValue11: yup.string().required("Transmiter is required!"),
  valueOfTransmitter: yup.string().required("Transmiter is required!"),
  valueOfIssuer: yup.string().required("Issuer is required!"),
//   province: yup.string().required("Issuer is required!"),
  valueOfContactPerson: yup.string().required("Contact Person is required!"),
});
